module.exports = __webpack_public_path__ + "img/logo-icon-app.2ea793ae.png";